export const GET_STATES_LIST = 'GET_STATES_LIST';
export const GET_STATES_LIST_SUCCESS = `${GET_STATES_LIST}_SUCCESS`;
